module.exports = __webpack_public_path__ + "media/images/scientifique-77a92b4afd0522e83513495b99f4fae4.svg";